// toolicons.js
// Dibuja íconos en canvas dentro de los botones del panel Tools.
// No toca lógica de herramientas, solo reemplaza el texto por canvas.

(function () {
  "use strict";

  function $(sel, root = document) { return root.querySelector(sel); }
  function $$(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function setupToolIcon(btn, tool) {
    // Limpia contenido y arma: canvas + label (opcional)
    btn.innerHTML = "";

    const row = document.createElement("div");
    row.className = "toolRow";

    const c = document.createElement("canvas");
    c.width = 30;
    c.height = 20;
    c.className = "toolIconCanvas";

    const label = document.createElement("span");
    label.className = "toolLabel";
    label.textContent = toolLabel(tool);

    row.appendChild(c);
    row.appendChild(label);
    btn.appendChild(row);

    drawIcon(c, tool);
  }

  function toolLabel(tool) {
    if (tool === "select") return "Select";
    if (tool === "arrow") return "Move";
    if (tool === "arrowDash") return "PASS";
    if (tool === "screen") return "SCREEN";
    if (tool === "dribble") return "DRIBBLE";
    if (tool === "text") return "Text";
    if (tool === "delete") return "Delete";
    return tool;
  }

  function drawIcon(canvas, tool) {
    const ctx = canvas.getContext("2d");
    const w = canvas.width, h = canvas.height;

    ctx.clearRect(0, 0, w, h);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "rgba(50, 50, 50, 0.92)";
    ctx.fillStyle = "rgba(50, 50, 50, 0.92)";

    // Helpers
    const p = (x, y) => ({ x, y });

    function line(a, b) {
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
    }

    function arrowHead(tip, ang, size) {
      const ca = Math.cos(ang), sa = Math.sin(ang);
      const a = size * 0.95;
      const b = size * 0.55;
      const p1 = tip;
      const p2 = p(tip.x - ca * a + sa * b, tip.y - sa * a - ca * b);
      const p3 = p(tip.x - ca * a - sa * b, tip.y - sa * a + ca * b);

      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.lineTo(p3.x, p3.y);
      ctx.closePath();
      ctx.fill();
    }

    function teeEnd(tip, ang, size) {
      const len = size * 1.05;
      const nx = -Math.sin(ang), ny = Math.cos(ang);
      const a = p(tip.x + nx * len, tip.y + ny * len);
      const b = p(tip.x - nx * len, tip.y - ny * len);
      const prev = ctx.getLineDash();
      ctx.setLineDash([]);
      line(a, b);
      ctx.setLineDash(prev);
    }

    // Layout base
    const start = p(5, h - 6);
    const end   = p(w - 6, 6);
    const ang = Math.atan2(end.y - start.y, end.x - start.x);

    if (tool === "arrow") {
      ctx.setLineDash([]);
      line(start, end);
      arrowHead(end, ang, 6);
      return;
    }

    if (tool === "arrowDash") {
      ctx.setLineDash([5, 4]);
      line(start, end);
      ctx.setLineDash([]);
      arrowHead(end, ang, 6);
      return;
    }

    if (tool === "screen") {
      ctx.setLineDash([]);
      line(start, end);
      teeEnd(end, ang, 7);
      return;
    }

    if (tool === "dribble") {
      // onda exagerada
      ctx.setLineDash([]);
      const amp = 4.5;
      const waveLen = 6.0;

      // Parametrizamos a lo largo del segmento start->end
      const dx = end.x - start.x, dy = end.y - start.y;
      const len = Math.hypot(dx, dy);
      const ux = dx / len, uy = dy / len;
      const nx = -uy, ny = ux;

      ctx.beginPath();
      for (let t = 0; t <= len; t += 1.5) {
        const phase = (t / waveLen) * Math.PI * 2;
        const wave = Math.sign(Math.sin(phase)) * Math.pow(Math.abs(Math.sin(phase)), 0.55);
        const off = wave * amp;

        const x = start.x + ux * t + nx * off;
        const y = start.y + uy * t + ny * off;

        if (t === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
      return;
    }

    if (tool === "text") {
      // "T" simple
      ctx.setLineDash([]);
      ctx.font = "700 13px system-ui, -apple-system, Segoe UI, Roboto, Arial";
      ctx.font = "700 13px system-ui, -apple-system, Segoe UI, Roboto, Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("T", w / 2, h / 2 + 0.5);
      return;
    }

    if (tool === "select") {
      // cursor/target simple
      ctx.setLineDash([]);
      const cx = w / 2, cy = h / 2;
      ctx.beginPath();
      ctx.arc(cx, cy, 5.5, 0, Math.PI * 2);
      ctx.stroke();
      line(p(cx - 9, cy), p(cx - 2, cy));
      line(p(cx + 2, cy), p(cx + 9, cy));
      line(p(cx, cy - 9), p(cx, cy - 2));
      line(p(cx, cy + 2), p(cx, cy + 9));
      return;
    }

    if (tool === "delete") {
      // X
      ctx.setLineDash([]);
      line(p(7, 6), p(w - 7, h - 6));
      line(p(w - 7, 6), p(7, h - 6));
      return;
    }
  }

function injectToolIcons() {
  const toolBtns = $$(
    ".toolList .toolItem, #arrowsModal [data-tool]"
  );

  if (!toolBtns.length) return;

  toolBtns.forEach(btn => {
    const tool = btn.dataset.tool;
    if (!tool) return;
    setupToolIcon(btn, tool);
  });
}

  // Run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectToolIcons);
  } else {
    injectToolIcons();
  }
})();
